import styled from 'styled-components';
import { Modal } from 'antd';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: 215px;
    padding: 16px 24px;

    border-radius: 12px;
    overflow: hidden;
  }

  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-close {
    top: 16px;
    right: 16px;
  }
`;

export const UploadArea = styled.div<{
  $dragActive: boolean;
  $hasError: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  border: 2px dashed
    ${({ theme, $dragActive, $hasError }) =>
      $hasError
        ? theme.palette.red.ERROR500
        : $dragActive
          ? theme.palette.secondary.main
          : theme.palette.gray[300]};
  border-radius: 8px;
  background-color: ${({ theme, $dragActive }) =>
    $dragActive ? theme.palette.blue[50] : theme.palette.background.default};
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 24px;

  border-color: ${({ theme, $hasError }) =>
    $hasError ? theme.palette.red.ERROR500 : theme.palette.secondary.main};
  background-color: ${({ theme, $hasError }) =>
    $hasError ? theme.palette.red.ERROR50 : theme.palette.blue[50]};

  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`;

export const UploadIcon = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  border: 1px solid ${({ theme }) => theme.palette.neutral[100]};
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.gray[400]};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const UploadText = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
  margin-bottom: 8px;
  text-align: center;

  span {
    color: ${({ theme }) => theme.palette.brand};
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const UploadSubtext = styled.div<{ $error?: boolean }>`
  font-size: 14px;
  color: ${({ theme, $error }) =>
    $error ? theme.palette.red.ERROR500 : theme.palette.text.secondary};
  text-align: center;
  margin-top: ${({ $error }) => ($error ? '8px' : '0')};
`;

export const FileInfo = styled.div`
  padding: 16px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border: 1px solid ${({ theme }) => theme.palette.gray[300]};
  border-radius: 8px;
  margin-bottom: 16px;
  position: relative;
`;

export const FileInfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const FileNameWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const FileName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.neutral[500]};
  flex: 1;
  margin-right: 12px;
  word-break: break-all;
`;

export const FileSize = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.neutral[400]};
`;

export const DeleteIcon = styled.button`
  border: none;
  background: none;
  color: ${({ theme }) => theme.palette.text.secondary};
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  margin-top: 8px;

  &:hover {
    background-color: ${({ theme }) => theme.palette.red.ERROR50};
    color: ${({ theme }) => theme.palette.red.ERROR500};
  }
`;

export const ProgressContainer = styled.div`
  position: relative;
  width: 100%;
  height: 8px;
  background-color: ${({ theme }) => theme.palette.gray[200]};
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
`;

export const ProgressBar = styled.div<{ $progress: number }>`
  height: 100%;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.palette.secondary.main} 0%,
    ${({ theme }) => theme.palette.blue[300]} 100%
  );
  width: ${({ $progress }) => $progress}%;
  transition: width 0.3s ease;
  border-radius: 4px;
`;

export const ProgressText = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: right;
  margin-top: 4px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
`;

export const WrapperIconByType = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.primary[100]};
  border-radius: 50%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 24px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 5px;
  background-color: ${({ theme }) => theme.palette.primary[50]};
  border-radius: 50%;
`;

export const StyledTitle = styled.div`
  font-size: 18px;
  line-height: 26px;
  font-weight: 600;
  margin-top: 12px;
  color: ${({ theme }) => theme.palette.text.primary};
`;
